import * as sonbp from "sonbp";
import * as ifbase from "../base";
import * as tool from '../tool'
import { poscaSelector } from "./poscaSelector";


/**
* ポスカ用セレクター（画像レイヤー用）
* @summary 描画オブジェクトの選択操作を行います。
* @summary 画像枠間での画像入替えができます。
*/
export class poscaSelectorWithExchange extends poscaSelector {

	// -----------------------------------------------
	// Constructors（コンストラクタ）
	// -----------------------------------------------

	public _onExchangeCallback: (a: { waku: any, img: any }, b: { waku: any, img: any }) => void;

	/**
	 * コンストラクタ
	 */
	public constructor(ifdto: ifbase.ifDto) {
		super(ifdto);
	}

	/**
	 * ２つの画像枠間で画像入替え
	 */
	public onExchange(callback: (a: { waku: any, img: any }, b: { waku: any, img: any }) => void) {
		this._onExchangeCallback = callback;
	}

	// -----------------------------------------------
	// Properties（内部変数）
	// -----------------------------------------------

	/**
	* 前回マウス位置
	*/
	protected _lastPt: sonbp.type.localViewPosition = null;

	/**
	* ドラッグイメージ
	*/
	protected _dragImage: HTMLImageElement = null;

	/**
	* ドラッグ元の画像枠
	*/
	protected _srcBox: sonbp.object.groupItem = null;

	/**
	* ドラッグ先候補の画像枠
	*/
	protected _dstBox: sonbp.object.groupItem = null;

	// -----------------------------------------------
	// Methods（外部アクセス用メソッド）
	// -----------------------------------------------


	// -----------------------
	// イベント受付機能 関数
	// -----------------------

	/**
	 * マウスダウン処理
	 * @override
	 */
	protected gevMousedown(e: MouseEvent, vp: sonbp.type.localViewPosition): sonbp.type.listerResult {

		let result = super.gevMousedown(e, vp);

		if (this._nextObject) {

			// ドラッグ開始準備
			this.dragReady(this._nextObject);
		}

		return result;
	}

	/**
	 * マウスムーブ処理
	 * 画像枠間入替えのON/OFFも兼ねる
	 * @override
	 */
	protected gevMousemove(e: MouseEvent, vp: sonbp.type.localViewPosition): sonbp.type.listerResult {

		let result = super.gevMousemove(e, vp);

		this._lastPt = vp;
		this._dstBox = null;

		if (this.getStateOnMouseEvent(e) == 1) {
			//左ボタン押下中

			// ドラッグ開始
			this.dragStart(this.getHitObject(vp.docPt));

		} else {
			//ドラッグしていない
			this.dragInit();
		}

		return result;
	}

	/**
	 * マウスアップ処理
	 * @override
	 */
	protected gevMouseup(e: MouseEvent, vp: sonbp.type.localViewPosition): sonbp.type.listerResult {

		var result = super.gevMouseup(e, vp);

		if (this._srcBox == null) return result;
		if (e.which != sonbp.constant.clickWhitch.LEFT) return result;

		let that = this;

		// ドロップ成立なら画像入替え
		let nextObject = this.getHitObject(vp.docPt);
		this.drop(nextObject, (res: boolean) => {
			if (!res) {
				that._ifdto.callbackOnApiError(e);
			}
		});

		result.isDrawEditCanvas = true;
		return result;
	}

	/**
	 * マウスアウト処理
	 * @override
	 */
	protected gevMouseout(e: MouseEvent, vp: sonbp.type.localViewPosition): sonbp.type.listerResult {

		if (this._srcBox != null) {
			console.debug("★★ドラッグ中のマウスアウト！");
			this.dragInit();
		}

		var result = super.gevMouseout(e, vp);
		result.isPrevent = true;

		return result;
	}

	// -----------------------
	// 描画機能 関数
	// -----------------------

	/**
	 * 選択アイテムの描画
	 * @override
	 */
	protected drawEditCanvasOfSelectItem(co: sonbp.draw.editCanvasOperator): void {

		co.ctx.save();
		super.drawEditCanvasOfSelectItem(co);
		co.ctx.restore();

		if (this._dragImage == null) return;

		// ドロップ先候補の描画
		if (this._dstBox != null && this._dstBox.id != this._srcBox.id) {

			co.ctx.save();
			co.ctx.strokeStyle = this._v._stl.dragCandiLineStyle;
			co.ctx.lineWidth = this._v._stl.dragCandiLineBorderWidth / this._v._dm.scaleRate
			co.ctx.setLineDash(this._v._stl.dragCandiLineDash);
			co.ctx.fillStyle = this._v._stl.dragCandiFillStyle;

			this._v._dm.pageTransform(this._dstBox._apply_pageIdx, co.ctx);

			sonbp.util.c2d.commandDraw(this._dstBox.clip_item._commands, co.ctx);
			co.ctx.fill();
			co.ctx.stroke();

			co.ctx.restore();
		}

		// ドラッグ中画像の描画
		co.ctx.save();
		{
			var srcImg = this._srcBox.childs[0];
			var srcRect = this._srcBox.rect;
			let srcMt = srcImg.matrix;

			this._v._dm.pageTransform(this._srcBox._apply_pageIdx, co.ctx);
			var m = this._v._dm.getCacheCurrentPageMatrix(0);

			var xsz = srcRect.width / 2 + srcRect.x1;
			var ysz = srcRect.height / 2 + srcRect.y1;
			var r = new sonbp.type.rectPoint(this._lastPt.docPt[0].x - xsz, this._lastPt.docPt[0].y - ysz, this._lastPt.docPt[0].x + xsz, this._lastPt.docPt[0].y + ysz);

			co.ctx.translate(r.x1, r.y1);
			co.ctx.transform(srcMt[0], srcMt[1], srcMt[2], srcMt[3], srcMt[4], srcMt[5]);

			var width = 1, height = 1;
			if (srcImg.subtype == sonbp.constant.itemSubType.FORM) width = srcImg.size[0], height = srcImg.size[1];

			co.ctx.transform(1, 0, 0, -1, 0, height);

			co.ctx.globalAlpha = this._v._stl.dragImageAlpha;
			co.ctx.drawImage(this._dragImage, 0, 0, width, height);
		}
		co.ctx.restore();
	}

	// -----------------------------------------------
	// Methods（内部関数）
	// -----------------------------------------------

	/**
	 * 選択初期化実処理 
	 * @override
	 **/
	protected dragInit(): void {
		this._dragImage = null;
		this._srcBox = null;
		this._dstBox = null;
	}

	/**
	 * ドラッグ準備
	 */
	protected dragPreparation(item: sonbp.object.groupItem): void {

		this._srcBox = item;
		this._dragImage = null;
	}

	/**
	 * ドラッグ開始準備
	 * @summary ここでは仕掛け用意のみ。実際にドラッグ開始するのはマウスmoveされたら。
	 */
	protected dragReady(nextObject: {
		item?: sonbp.object.baseItem,
		snap?: sonbp.type.selectSnapLine,
		area?: sonbp.type.selectArea
	}): void {

		// 交換先なければ無用
		let layer = this._ifdto.bpView._om._doc.pages[0].layers.filter(d => d.info.vendor_property.ffpsc?.layer_type == ifbase.constants.LTYPE_PHOTO)[0];
		let items = ifbase.util.getItems(layer.items, function (item: sonbp.object.baseItem): boolean {
			return ifbase.util.chkIsPhotobox(item);
		});
		if (items.length < 2) return;
		if (!ifbase.util.chkIsPhotobox(nextObject?.item)) return;

		let selItem = nextObject?.item as sonbp.object.groupItem;
		let fileId = selItem?.childs[0].info.vendor_property.ffpsc?.file_id;
		if (selItem && fileId != "@DUMMY@") {
			//ドラッグ開始の準備
			this.dragPreparation(nextObject.item as sonbp.object.groupItem);
		}
	}

	/**
	 * ドラッグ開始
	 */
	protected dragStart(dstObject: {
		item?: sonbp.object.baseItem,
		snap?: sonbp.type.selectSnapLine,
		area?: sonbp.type.selectArea
	}): void {

		if (this._srcBox != null && this._dragImage == null) {
			console.debug("ドラッグ開始");

			let img = this._srcBox.childs[0] as sonbp.object.xobjectItem;
			let imgData = this._v._cm.getImg(img.src);
			this._dragImage = new Image();
			this._dragImage.src = imgData.img.src;
		}
		this._dstBox = dstObject?.item as sonbp.object.groupItem;
	}

	/**
	 * ドロップ実施
	 */
	protected drop(nextObject: {
		item?: sonbp.object.baseItem,
		snap?: sonbp.type.selectSnapLine,
		area?: sonbp.type.selectArea
	}, callback: (res: boolean) => void): void {

		if (nextObject != null && nextObject.item.id != this._srcBox.id) {

			console.debug("ドロップ。画像入替え");

			let srcId = this._srcBox.id;
			let dstId = nextObject.item.id;

			let that = this;
			tool.photoMani.exchangePhotoImg(this._ifdto, srcId, dstId,
				function () {
					if (that._onExchangeCallback) {
						let refInfos = sonbp.tool.item.getRefInfos(that._ifdto.bpView, [srcId, dstId]);
						let a = {
							waku: refInfos[0].item.info.vendor_property.ffpsc,
							img: (<sonbp.object.groupItem>refInfos[0].item).childs[0].info.vendor_property.ffpsc
						};
						let b = {
							waku: refInfos[1].item.info.vendor_property.ffpsc,
							img: (<sonbp.object.groupItem>refInfos[1].item).childs[0].info.vendor_property.ffpsc
						};
						that._onExchangeCallback(a, b);
					}
					console.log("[sonbpIf] exchangePhotoImg success.");
					callback(true);
				},
				function (e) {

					console.log("[sonbpIf] exchangePhotoImg error.", e);
					callback(false);
				});
		}
		else {

			console.debug("gevMouseup out.");
		}

		this.dragInit();
	}

}